export default __webpack_public_path__ + "static/media/woman1.aa12fe64.jpg";